export default __webpack_public_path__ + "static/media/InnerView.3c1120cf.jpeg";